import React from 'react';
import type { UserVoteInfo } from '../types';

interface VoteInfoBannerProps {
  userVoteInfo: UserVoteInfo | null;
  isLoaded: boolean;
}

const VoteInfoBanner: React.FC<VoteInfoBannerProps> = ({ userVoteInfo, isLoaded }) => {
  if (!isLoaded) {
    return (
      <div className="bg-primary-50 border border-primary-200 rounded-lg px-4 py-3 flex items-center justify-between animate-pulse">
        <div className="flex items-center gap-2 text-sm text-primary-600">
          <i className="fa-light fa-circle-info" />
          <span className="text-neutral-400">Laden...</span>
        </div>
        <div className="flex gap-2 items-center">
          {Array.from({ length: 3 }).map((_, i) => (
            <i
              key={i}
              className="fa-light fa-thumbs-up text-primary-200 text-sm"
              aria-hidden="true"
            />
          ))}
        </div>
      </div>
    );
  }

  if (!userVoteInfo) return null;

  const { activeVotes, maxVotes, remainingVotes } = userVoteInfo;

  return (
    <div className="bg-primary-50 border border-primary-200 rounded-lg px-4 py-3 flex items-center justify-between">
      <div className="flex items-center gap-2 text-sm text-primary-600">
        <i className="fa-light fa-circle-info" />
        <span>
          Je hebt nog <strong>{remainingVotes}</strong>{' '}
          {remainingVotes === 1 ? 'stem' : 'stemmen'} beschikbaar
        </span>
      </div>
      <div className="flex gap-2 items-center">
        {Array.from({ length: maxVotes }).map((_, i) => (
          <i
            key={i}
            className={`fa-light fa-thumbs-up ${
              i < activeVotes ? 'text-primary-600' : 'text-primary-200'
            } text-sm`}
            aria-hidden="true"
            title={i < activeVotes ? 'Used vote' : 'Available vote'}
          />
        ))}
      </div>
    </div>
  );
};

export default VoteInfoBanner;
